import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IStaticTextStore,
  StaticText,
  STATIC_TEXT_APP,
  GetStaticTextsOptions,
  StaticTextStatus,
} from '../../mobx-store/storeInterfaces/staticTextInterface';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import { RouteComponentProps } from 'react-router';
import { Box, Button } from '@material-ui/core';

interface RouteParams {
  app: STATIC_TEXT_APP;
}

type IProps = WithSnackbarProps & RouteComponentProps<RouteParams> & {
  staticTextStore: IStaticTextStore;
};

interface TableData {
  key: string;
  value: string;
  edit: string;
}
interface State {
  selectedCategory: string;
  selectedStatus: StaticTextStatus;
  categories: string[];
}

@inject('staticTextStore')
@observer
class StaticTexts extends Component<IProps, State> {
  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Static Text Management';

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedCategory: '',
      selectedStatus: StaticTextStatus.ALL,
      categories: [],
    }
  }

  getCurrentApp = (props: IProps) => {
    return props.match.params.app;
  }

  staticTextCategories = (staticTexts: StaticText[]) => {
    return Array.from(new Set(staticTexts.map((staticText) => staticText.category))).sort();
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    const staticTextCategories = this.staticTextCategories(this.props.staticTextStore.staticTextsList);
    const currentCategory = this.state.selectedCategory || staticTextCategories[0];
    const currentStaticTexts = this.getStaticTextTableData(this.props.staticTextStore.staticTextsList, currentCategory);
    window.open(`${window.location.origin}/staticTexts/${this.getCurrentApp(this.props)}/${currentStaticTexts[index].key}/edit`, '_blank');
  };

  getStaticTextKeyStatus = () => [
    {
      name: StaticTextStatus.NEW,
      value: StaticTextStatus.NEW,
    },
    {
      name: StaticTextStatus.OLD,
      value: StaticTextStatus.OLD,
    },
    {
      name: StaticTextStatus.ALL,
      value: StaticTextStatus.ALL,
    }
  ];

  getStaticTextTableHeader = () => [
    {
      title: translate('staticTextsCategoryColumnTitle', {
      }),
    },
    {
      title: translate('staticTextsKeysColumnTitle', {
      }),
    },
    {
      title: translate('staticTextsValueColumnTitle', {
      }),
    },
    {
      title: translate('staticTextsEditColumnTitle', {
      }),
    },
  ];

  getStaticTextTableData = (staticTexts: StaticText[], selectedCategory: string): TableData[] => staticTexts
    .filter((staticText) => staticText.category === selectedCategory)
    .map((staticText: StaticText) => {
      const staticTextData = {
        category: staticText.getCategory(),
        key: staticText.getKey(),
        value: staticText.getValue(),
        edit: 'Edit',
      };
      return staticTextData;
    });
  getStaticTextTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'category',
    },
    {
      cellType: 'Text',
      key: 'key',
    },
    {
      cellType: 'Text',
      key: 'value',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];
  filterStaticTextsByStatus = (status: StaticTextStatus) => {
    this.setState({
      selectedStatus: status,
    });

    const params: GetStaticTextsOptions  = {
    };
    if ( status !== StaticTextStatus.ALL) {
      params.keys = status;
      params.category = this.state.selectedCategory.length ? this.state.selectedCategory : undefined;
    }
    this.props.staticTextStore.getStaticTexts(this.getCurrentApp(this.props), params, languageCodes.english)
  }
  filterStaticTextsByCategory = (status: string) => {
    console.log(status);
    this.setState({
      selectedCategory: status,
    });
    this.props.staticTextStore.getStaticTexts(this.getCurrentApp(this.props), {
      category: status,
      keys: this.state.selectedStatus,
    },languageCodes.english);
  }

  render() {
    this.tableHeader = this.getStaticTextTableHeader();
    this.tableCellTypes = this.getStaticTextTableCellTypes();
    // const staticTextCategories = this.staticTextCategories(this.props.staticTextStore.staticTextsList);
    const staticTextKeysStatus = this.getStaticTextKeyStatus();
    const currentCategory = this.state.selectedCategory || this.state.categories[0];
    return (
      <div>
        {
          (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <SearchFilterDropdown
                label={'Category'}
                searchFilterDropdown={{
                  filters: this.state.categories.map((category) => ({ value: category, name: category })),
                  value: currentCategory,
                  initialValue: this.state.categories[0],
                  onChange: (status) => this.filterStaticTextsByCategory(status)
                }}
              />
              <SearchFilterDropdown
                label={'Status'}
                searchFilterDropdown={{
                  filters: staticTextKeysStatus,
                  value: this.state.selectedStatus,
                  initialValue: StaticTextStatus.ALL,
                  onChange: (status) => this.filterStaticTextsByStatus(status as StaticTextStatus)
                }}
              />
            </div>
          )
        }
        <Box display="flex" justifyContent="space-between">
          <h3>{this.title}</h3>
          <Button onClick={() => {
              window.open(`${window.location.origin}/staticTexts/${this.getCurrentApp(this.props)}/new`, '_blank');
          }} color="primary" variant='contained'>
            {translate('NEW')}
          </Button>
        </Box>

        <GeneralTableComponent
          emptyMessage='There are no static texts yet. Please add one now'
          tableHeader={this.tableHeader}
          tableData={this.getStaticTextTableData(this.props.staticTextStore.staticTextsList, currentCategory)}
          tableCellTypes={this.tableCellTypes}
          loadingStatus={[
            this.props.staticTextStore.getStaticTextsRequestStatus
          ]}
        />
      </div>
    );
  }
  async componentDidMount() {
    await this.props.staticTextStore.getStaticTexts(this.getCurrentApp(this.props), {}, languageCodes.english);
    this.setState({
      categories: this.staticTextCategories(this.props.staticTextStore.staticTextsList)
    })
  }

  componentDidUpdate(prevProps: IProps) {
    const oldApp = this.getCurrentApp(prevProps);
    const newApp = this.getCurrentApp(this.props);
    if (oldApp !== newApp) {
      this.setState({
        selectedCategory: '',
      });
      this.props.staticTextStore.getStaticTexts(newApp, {},languageCodes.english);
    }
  }
}

export default StaticTexts;
